import { Component, OnInit, OnDestroy } from "@angular/core";
import noUiSlider from "nouislider";
@Component({
  selector: "app-markets",
  templateUrl: "markets.component.html",
  styleUrls: ["markets.component.scss"]
})
export class MarketsComponent implements OnInit, OnDestroy {
  focus;
  focus1;
  focus2;
  date = new Date();
  pagination = 3;
  pagination1 = 1;
  constructor() {}
  ngOnInit() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("index-page");
    var element = document.getElementById("navigation");
    element.click();

  }
  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("index-page");
  }
}
